module.exports = __webpack_public_path__ + "img/book.aa5ae630.svg";